import axios from 'axios'
import { i18n } from '../../plugins/i18n'

export const companiesCompanyAddress = {
  namespaced: true,
  state: {
    company_address: {
      id: null,
      company_name: '',
      email: '',
      postal_code: '',
      responsible_name: '',
      city_street: '',
      building: '',
      phone_number: '',
      prefecture: '',
    },
    loading: false,
    loadError: false,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
      state.loadError = false
    },
    setCompanyAddress(state, { payload }) {
      state.company_address = {
        id: payload.data.id,
        company_name: payload.data.attributes.company_name,
        email: payload.data.attributes.email,
        postal_code: payload.data.attributes.postal_code,
        city_street: payload.data.attributes.city_street,
        building: payload.data.attributes.building,
        responsible_name: payload.data.attributes.responsible_name,
        phone_number: payload.data.attributes.phone_number,
        prefecture: payload.data.attributes.prefecture,
      }
      state.loading = false
    },
    getErrorResponse(state) {
      state.loading = false
      state.loadError = true
    },
  },
  actions: {
    readCompanyAddress({ commit }, companyUuid) {
      commit('apiConnect')
      return axios
        .get('/api/companies/' + companyUuid + '/address.json')
        .then(res => {
          commit('setCompanyAddress', { payload: res.data })
        })
        .catch(err => {
          commit('getErrorResponse', err)
          console.error(err)
        })
    },
    writeCompanyAddress({ commit, state }, { companyUuid, payload }) {
      if (state.loading) return

      commit('flash/clearFlash', null, { root: true })
      commit('apiConnect')
      if (state.company_address.id) {
        axios
          .patch('/api/companies/'+ companyUuid +'/address', payload)
          .then(res => {
            const payload = res.data
            payload.companyUuid = companyUuid
            commit('setCompanyAddress', { payload: payload, message: i18n.t('messages.updated', { value: i18n.t('models.company.address.modelName') })})
            commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.company.address.modelName') }) }, { root: true })
          })
          .catch(err => {
            commit('getErrorResponse')
            commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
            console.error(err)
          })
        return
      }
      axios
        .post('/api/companies/'+ companyUuid +'/address', payload)
        .then(res => {
          const payload = res.data
          payload.companyUuid = companyUuid
          commit('setCompanyAddress', { payload: payload, message: i18n.t('messages.created', { value: i18n.t('models.company.address.modelName') })})
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.company.address.modelName') })}, { root: true })
        })
        .catch(err => {
          commit('getErrorResponse')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    }
  }
}
